import { z } from 'zod';
// =========================================================
// Schemas Zod para GET /api/plantas.
// Naming snake_case en el response para matchear columnas SQL.
// =========================================================
export const PlantaResumenSchema = z.object({
    id: z.number().int().positive(),
    codigo: z.string().min(1),
    marca: z.string().min(1),
    serial: z.string().min(1),
});
export const ListaPlantasResponseSchema = z.object({
    plantas: z.array(PlantaResumenSchema),
});
//# sourceMappingURL=plantas.js.map